import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const getPhone = id =>
  axios({
    method: 'get',
    url: `${publicAPI}/order/getphone/${id}`,
  });
